import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';

import { SearchStats } from '@uncinc/react-searchkit';

import './style.scss';

interface SearchStatsProps {
  className?: string
}

const SearchAllContentStats: React.FC<SearchStatsProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div className={c('SearchAllContentStats', className)}>
      <SearchStats
        translation={(amount) => t('components.search.stats.count', { amount })}
      />
    </div>
  );
};

export default SearchAllContentStats;
